// eslint-disable-next-line import/no-anonymous-default-export
export default {
  menu: {
    name: "云扩RPA管理后台",
    userManagement: {
      name: "用户管理",
    },
    company: {
      name: "公司管理",
      enterprise: {
        name: "企业版用户管理",
      },
      community: {
        name: "社区版用户管理",
      },
    },
    license: {
      name: "许可证",
      list: {
        name: "许可证管理",
      },
      studio: {
        name: "编辑器许可证",
      },
      premiumRobot: {
        name: "高级机器人许可证",
      },
      localOCR: {
        name: "本地OCR许可证",
      },
      console: {
        name: "控制台许可证",
      },
    },
    installation: {
      name: "安装包管理",
    },
    aiManagement: {
      name: "AI管理",
      user: {
        name: "账户管理",
      },
      userService: {
        name: "账户服务管理",
      },
      service: {
        name: "服务管理",
      },
    },
  },
  info: {
    requestError: "请求错误",
  },
};
